import axios from "axios";

const isBt = process.env.BRAND === 'bt';

class BenchClient {
  static properties = {};
  static iValue = isBt ? 3200 : 3100;
  static endpoint = isBt ? 'https://btbench.bittorrent.com' : "https://utbench.utorrent.com";

  static ping(properties = {}) {
    const data = {
      eventName: isBt ? 'btwebsite' : 'utwebsite',
      action: properties,
      ...BenchClient.properties
    };
    return axios.get(`${BenchClient.endpoint}/e?i=${BenchClient.iValue}&e=${btoa(JSON.stringify(data))}`);
  }

  static stick(properties = {}) {
    BenchClient.properties = {
      ...BenchClient.properties,
      ...properties,
    };
  }
}

export default BenchClient;